import React from 'react';

interface CloseIconProps {
  size?: number;
  color?: string;
}

const CloseIcon: React.FC<CloseIconProps> = ({
  size = 12,
  color = 'currentColor',
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.5714 0.428571L0.428571 11.5714"
      stroke={color}
      strokeWidth="0.857143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M0.428571 0.428571L11.5714 11.5714"
      stroke={color}
      strokeWidth="0.857143"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default CloseIcon;
